// Define a personal statement class
class PersonalStatement {
  statement: string[];
  constructor(statement: string[]) {
    this.statement = statement;
  }
}

export default PersonalStatement;
